import { ChangeState } from '../change-state/change-state';
import { SyncStatusEnum } from './sync-status.enum';

export class SyncState {
  constructor(init?: Partial<SyncState>) {
    if (init)  {
      Object.assign(this, init);
      if (init.date) {
        this.date = new Date(init.date);
      }
    }
  }
  date: Date;
  changes: Array<ChangeState<any>>;
  error: any;
  status: SyncStatusEnum;
}
